import axios from "axios";
import { useState } from "react";
import { APIConstants } from "../../constants/ApiConstants";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { memberActions } from "../../redux/slices/memberSlice";
import { loyaltyPointsActions } from "../../redux/slices/UpdateLoyaltyPoints";

export let memberDetailsRefresh: Function;

const useGetMemberDetails = (search: string) => {
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getMemberDetails = async (query: any) => {
    try {
      setLoading(true);
      const memberDetails = await axios.get(
        process.env.REACT_APP_API_URL +
          `${APIConstants.getCustomer}?id=${query}`
      );
      const mappedData = memberDetails?.data?.data?.data;

      const countryCodeMatch = mappedData?.storecountrycode?.match(/([0-9]+)/);
      const mobileUpdated = mappedData?.mobile?.replace(
        new RegExp(`^${countryCodeMatch?.[0]}`),
        ""
      );

      mappedData.mobileWOCc = mobileUpdated;

      // Create a new object reference to ensure React detects the change
      const updatedMemberData = { ...mappedData };
      dispatch(
        memberActions.updateMemberList({
          membersList: updatedMemberData,
        })
      );
      dispatch(
        loyaltyPointsActions.updatePoints({
          points: mappedData.loyaltyPoints,
        })
      );
      const location = window.location.pathname.split("/");
      const pathname = location[location.length - 1];
      const currentPath = window.location.pathname;

      // BACKUP SOLUTION: Manually ensure data is in localStorage
      // This guarantees persistence even if Redux Persist is slow
      try {
        const persistRoot = localStorage.getItem("persist:root");
        if (persistRoot) {
          const parsed = JSON.parse(persistRoot);
          // Manually update the membersList in localStorage
          const existingMemberData = parsed.getMemberList
            ? JSON.parse(parsed.getMemberList)
            : {};
          existingMemberData.membersList = mappedData;
          parsed.getMemberList = JSON.stringify(existingMemberData);
          localStorage.setItem("persist:root", JSON.stringify(parsed));
          console.log("💾 Manually saved to localStorage as backup");
          console.log(
            "localStorage membersList keys:",
            Object.keys(mappedData).length
          );
        }
      } catch (e) {
        console.error("Error manually saving to localStorage:", e);
      }
      // Still wait a bit for Redux Persist's own save mechanism
      await new Promise((resolve) => setTimeout(resolve, 100));
      // Pass member data via navigation state as backup
      const navigationState = {
        memberDetails: mappedData,
        loyaltyPoints: mappedData.loyaltyPoints,
        timestamp: Date.now(),
      };

      // Check if we're already on the target page - if so, use replace to force refresh
      switch (pathname) {
        case "sales":
          if (currentPath.includes("/sales")) {
            navigate(`/sales`, { state: navigationState, replace: true });
          } else {
            navigate(`/sales`, { state: navigationState });
          }
          break;
        case "memberRedemption":
          if (currentPath.includes("/memberRedemption")) {
            navigate(`/memberRedemption`, {
              state: navigationState,
              replace: true,
            });
          } else {
            navigate(`/memberRedemption`, { state: navigationState });
          }
          break;
        case "members":
        case "viewMember":
          // If already on viewMember, use replace to force refresh without adding to history
          if (
            currentPath.includes("/viewMember") ||
            currentPath.includes("/members")
          ) {
            navigate(`/viewMember`, { state: navigationState, replace: true });
          } else {
            navigate(`/viewMember`, { state: navigationState });
          }
          break;
        case "redirect":
          navigate(`/viewMember`, { state: navigationState, replace: true });
          break;
        default:
          // If pathname doesn't match any case, but we're on viewMember, refresh it
          if (currentPath.includes("/viewMember")) {
            navigate(`/viewMember`, { state: navigationState, replace: true });
          }
          break;
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("error", error);
    }
  };

  return {
    getMemberDetails,
    loading,
  };
};

export default useGetMemberDetails;
